import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Home.css';

const Home = () => (
  <div className="home">
    <Helmet>
      <title>Portugal Pavilion at Carassauga 2025 | Portuguese Culture Mississauga</title>
      <meta name="description" content="Experience authentic Portuguese culture at Carassauga 2025! Join us for traditional food, music, dance, and cultural activities. Get your tickets, view our schedule, and explore our menu featuring delicious Portuguese cuisine." />
      <meta name="keywords" content="Portugal, Portuguese culture, Carassauga 2025, Mississauga, Portuguese food, Portuguese music, Portuguese dance, cultural festival, Portugal Pavilion, PCCM, Portuguese Cultural Centre" />
      <link rel="canonical" href="https://carassauga2025.web.app/" />
    </Helmet>
    <video autoPlay muted loop playsInline className="background-video">
    <source src="/videos/dove.mp4" type="video/mp4" />
    </video>

    <div className="hero-overlay">
      <img src="/images/landing/carassauga-title.svg" alt="Carassauga Title" className="gold-deco" />
      <div className="year">2025</div>
      <div className="circle-btns">
        <Link to="/passports" className="circle-btn">
          <img src="/images/passport/passports-icon0.svg" alt="Passports" />
          <p>Tickets</p>
        </Link>
        <Link to="/schedule" className="circle-btn">
          <img src="/images/schedule/schedule-icon.svg" alt="Schedule" />
          <p>Program</p>
        </Link>
        <Link to="/menu" className="circle-btn">
          <img src="/images/menu/menus-icon0.svg" alt="Menu" />
          <p>Menu</p>
        </Link>
        <Link to="/toonie-taste" className="circle-btn">
          <img src="/images/toonie/group-1060.svg" alt="Toonie Taste" />
          <p>Toonie Taste</p>
        </Link>
      </div>
    </div>

    <footer className="footer">
      <div><strong>PORTUGAL CULTURAL CENTRE OF MISSISSAUGA</strong><br />www.pccmississauga.ca</div>
      <div className="footer-links">
        <div><p>RANCHO PCCM</p><span>@pccmfolcloregroup</span></div>
        <div><p>INSTAGRAM</p><span>@pccmississauga</span></div>
        <div><p>PORTUGAL PAVILLION INSTAGRAM</p><span>@PCCM_PortugalPavilion</span></div>
      </div>
      <div className="signature">METAFORMA STUDIO</div>
    </footer>
  </div>
);

export default Home;
